import React, {useEffect} from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withDelay,
  withTiming,
  Easing,
} from 'react-native-reanimated';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  distance?: number;
  style?: StyleProp<ViewStyle>;
}

/**
 * Fade + rise entrance for a section/card. Give each item in a sequence an
 * increasing `delay` (e.g. index * 60) to stagger a list/grid in as it mounts.
 */
export default function Reveal({
  children,
  delay = 0,
  duration = 380,
  distance = 14,
  style,
}: RevealProps) {
  const progress = useSharedValue(0);

  useEffect(() => {
    progress.value = withDelay(
      delay,
      withTiming(1, {duration, easing: Easing.out(Easing.cubic)}),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: progress.value,
    transform: [{translateY: (1 - progress.value) * distance}],
  }));

  return <Animated.View style={[style, animatedStyle]}>{children}</Animated.View>;
}
